import clsx from 'clsx';
import { graphql } from 'gatsby';
import { forwardRef } from 'react';
import { BaseLink } from '~components/BaseLink';
import { useHref } from './useHref';

import * as styles from './ComponentLink.module.css';

import type { BaseLinkProps } from '~components/BaseLink';
import type { ContentfulComponentLink, LinkTarget } from './types';

export type ComponentLinkProps = Omit<BaseLinkProps, 'href' | 'target'> & {
  link: ContentfulComponentLink;
  activeClassName?: string;
};

export const ComponentLink = forwardRef<HTMLAnchorElement, ComponentLinkProps>(
  ({ link, children, className, ...props }, ref) => {
    const href = useHref(link);

    return (
      <BaseLink
        ref={ref}
        {...props}
        href={href}
        target={mapTarget(link.target)}
        trackingId={link.label}
        className={clsx(styles.link, className)}
      >
        {children}
      </BaseLink>
    );
  },
);

const mapTarget = (target?: LinkTarget): string => {
  switch (target) {
    case 'New Tab':
      return '_blank';
    case 'Same Tab':
    default:
      return '_self';
  }
};

export const query = graphql`
  fragment ComponentLink on ContentfulComponentLink {
    __typename
    contentful_id
    label
    to
    page {
      id
    }
    target
    description
    icon {
      ...MixedMedia
    }
  }
`;
